export const paddingVariants = {
  padding: {
    0: 'p-0',
    1: 'p-1',
    2: 'p-2',
    3: 'p-3',
    4: 'p-4',
    5: 'p-5',
    6: 'p-6',
    8: 'p-8',
    9: 'p-9',
    10: 'p-10',
    12: 'p-12',
    16: 'p-16',
    18: 'p-18',
    20: 'p-20',
    24: 'p-24',
    32: 'p-32',
    40: 'p-40',
    48: 'p-48',
    56: 'p-56',
    64: 'p-64',
  },
  'padding-sm': {
    0: 'sm:p-0',
    1: 'sm:p-1',
    2: 'sm:p-2',
    3: 'sm:p-3',
    4: 'sm:p-4',
    5: 'sm:p-5',
    6: 'sm:p-6',
    8: 'sm:p-8',
    9: 'sm:p-9',
    10: 'sm:p-10',
    12: 'sm:p-12',
    16: 'sm:p-16',
    18: 'sm:p-18',
    20: 'sm:p-20',
    24: 'sm:p-24',
    32: 'sm:p-32',
    40: 'sm:p-40',
    48: 'sm:p-48',
    56: 'sm:p-56',
    64: 'sm:p-64',
  },
  'padding-md': {
    0: 'md:p-0',
    1: 'md:p-1',
    2: 'md:p-2',
    3: 'md:p-3',
    4: 'md:p-4',
    5: 'md:p-5',
    6: 'md:p-6',
    8: 'md:p-8',
    9: 'md:p-9',
    10: 'md:p-10',
    12: 'md:p-12',
    16: 'md:p-16',
    18: 'md:p-18',
    20: 'md:p-20',
    24: 'md:p-24',
    32: 'md:p-32',
    40: 'md:p-40',
    48: 'md:p-48',
    56: 'md:p-56',
    64: 'md:p-64',
  },
  'padding-leftg': {
    0: 'lg:p-0',
    1: 'lg:p-1',
    2: 'lg:p-2',
    3: 'lg:p-3',
    4: 'lg:p-4',
    5: 'lg:p-5',
    6: 'lg:p-6',
    8: 'lg:p-8',
    9: 'lg:p-9',
    10: 'lg:p-10',
    12: 'lg:p-12',
    16: 'lg:p-16',
    18: 'lg:p-18',
    20: 'lg:p-20',
    24: 'lg:p-24',
    32: 'lg:p-32',
    40: 'lg:p-40',
    48: 'lg:p-48',
    56: 'lg:p-56',
    64: 'lg:p-64',
  },
  'padding-xl': {
    0: 'xl:p-0',
    1: 'xl:p-1',
    2: 'xl:p-2',
    3: 'xl:p-3',
    4: 'xl:p-4',
    5: 'xl:p-5',
    6: 'xl:p-6',
    8: 'xl:p-8',
    9: 'xl:p-9',
    10: 'xl:p-10',
    12: 'xl:p-12',
    16: 'xl:p-16',
    18: 'xl:p-18',
    20: 'xl:p-20',
    24: 'xl:p-24',
    32: 'xl:p-32',
    40: 'xl:p-40',
    48: 'xl:p-48',
    56: 'xl:p-56',
    64: 'xl:p-64',
  },
  'padding-x': {
    0: 'px-0',
    1: 'px-1',
    2: 'px-2',
    3: 'px-3',
    4: 'px-4',
    5: 'px-5',
    6: 'px-6',
    8: 'px-8',
    9: 'px-9',
    10: 'px-10',
    12: 'px-12',
    16: 'px-16',
    18: 'px-18',
    20: 'px-20',
    24: 'px-24',
    32: 'px-32',
    40: 'px-40',
    48: 'px-48',
    56: 'px-56',
    64: 'px-64',
  },
  'padding-x-sm': {
    0: 'sm:px-0',
    1: 'sm:px-1',
    2: 'sm:px-2',
    3: 'sm:px-3',
    4: 'sm:px-4',
    5: 'sm:px-5',
    6: 'sm:px-6',
    8: 'sm:px-8',
    9: 'sm:px-9',
    10: 'sm:px-10',
    12: 'sm:px-12',
    16: 'sm:px-16',
    18: 'sm:px-18',
    20: 'sm:px-20',
    24: 'sm:px-24',
    32: 'sm:px-32',
    40: 'sm:px-40',
    48: 'sm:px-48',
    56: 'sm:px-56',
    64: 'sm:px-64',
  },
  'padding-x-md': {
    0: 'md:px-0',
    1: 'md:px-1',
    2: 'md:px-2',
    3: 'md:px-3',
    4: 'md:px-4',
    5: 'md:px-5',
    6: 'md:px-6',
    8: 'md:px-8',
    9: 'md:px-9',
    10: 'md:px-10',
    12: 'md:px-12',
    16: 'md:px-16',
    18: 'md:px-18',
    20: 'md:px-20',
    24: 'md:px-24',
    32: 'md:px-32',
    40: 'md:px-40',
    48: 'md:px-48',
    56: 'md:px-56',
    64: 'md:px-64',
  },
  'padding-x-lg': {
    0: 'lg:px-0',
    1: 'lg:px-1',
    2: 'lg:px-2',
    3: 'lg:px-3',
    4: 'lg:px-4',
    5: 'lg:px-5',
    6: 'lg:px-6',
    8: 'lg:px-8',
    9: 'lg:px-9',
    10: 'lg:px-10',
    12: 'lg:px-12',
    16: 'lg:px-16',
    18: 'lg:px-18',
    20: 'lg:px-20',
    24: 'lg:px-24',
    32: 'lg:px-32',
    40: 'lg:px-40',
    48: 'lg:px-48',
    56: 'lg:px-56',
    64: 'lg:px-64',
  },
  'padding-x-xl': {
    0: 'xl:px-0',
    1: 'xl:px-1',
    2: 'xl:px-2',
    3: 'xl:px-3',
    4: 'xl:px-4',
    5: 'xl:px-5',
    6: 'xl:px-6',
    8: 'xl:px-8',
    9: 'xl:px-9',
    10: 'xl:px-10',
    12: 'xl:px-12',
    16: 'xl:px-16',
    18: 'xl:px-18',
    20: 'xl:px-20',
    24: 'xl:px-24',
    32: 'xl:px-32',
    40: 'xl:px-40',
    48: 'xl:px-48',
    56: 'xl:px-56',
    64: 'xl:px-64',
  },
  'padding-y': {
    0: 'py-0',
    1: 'py-1',
    2: 'py-2',
    3: 'py-3',
    4: 'py-4',
    5: 'py-5',
    6: 'py-6',
    8: 'py-8',
    9: 'py-9',
    10: 'py-10',
    12: 'py-12',
    16: 'py-16',
    18: 'py-18',
    20: 'py-20',
    24: 'py-24',
    32: 'py-32',
    40: 'py-40',
    48: 'py-48',
    56: 'py-56',
    64: 'py-64',
  },
  'padding-y-sm': {
    0: 'sm:py-0',
    1: 'sm:py-1',
    2: 'sm:py-2',
    3: 'sm:py-3',
    4: 'sm:py-4',
    5: 'sm:py-5',
    6: 'sm:py-6',
    8: 'sm:py-8',
    9: 'sm:py-9',
    10: 'sm:py-10',
    12: 'sm:py-12',
    16: 'sm:py-16',
    20: 'sm:py-20',
    24: 'sm:py-24',
    32: 'sm:py-32',
    40: 'sm:py-40',
    48: 'sm:py-48',
    56: 'sm:py-56',
    64: 'sm:py-64',
  },
  'padding-y-md': {
    0: 'md:py-0',
    1: 'md:py-1',
    2: 'md:py-2',
    3: 'md:py-3',
    4: 'md:py-4',
    5: 'md:py-5',
    6: 'md:py-6',
    8: 'md:py-8',
    9: 'md:py-9',
    10: 'md:py-10',
    12: 'md:py-12',
    16: 'md:py-16',
    18: 'md:py-18',
    20: 'md:py-20',
    24: 'md:py-24',
    32: 'md:py-32',
    40: 'md:py-40',
    48: 'md:py-48',
    56: 'md:py-56',
    64: 'md:py-64',
  },
  'padding-y-lg': {
    0: 'lg:py-0',
    1: 'lg:py-1',
    2: 'lg:py-2',
    3: 'lg:py-3',
    4: 'lg:py-4',
    5: 'lg:py-5',
    6: 'lg:py-6',
    8: 'lg:py-8',
    9: 'lg:py-9',
    10: 'lg:py-10',
    12: 'lg:py-12',
    16: 'lg:py-16',
    18: 'lg:py-18',
    20: 'lg:py-20',
    24: 'lg:py-24',
    32: 'lg:py-32',
    40: 'lg:py-40',
    48: 'lg:py-48',
    56: 'lg:py-56',
    64: 'lg:py-64',
  },
  'padding-y-xl': {
    0: 'xl:py-0',
    1: 'xl:py-1',
    2: 'xl:py-2',
    3: 'xl:py-3',
    4: 'xl:py-4',
    5: 'xl:py-5',
    6: 'xl:py-6',
    8: 'xl:py-8',
    9: 'xl:py-9',
    10: 'xl:py-10',
    12: 'xl:py-12',
    16: 'xl:py-16',
    18: 'xl:py-18',
    20: 'xl:py-20',
    24: 'xl:py-24',
    32: 'xl:py-32',
    40: 'xl:py-40',
    48: 'xl:py-48',
    56: 'xl:py-56',
    64: 'xl:py-64',
  },
  'padding-top': {
    0: 'pt-0',
    1: 'pt-1',
    2: 'pt-2',
    3: 'pt-3',
    4: 'pt-4',
    5: 'pt-5',
    6: 'pt-6',
    8: 'pt-8',
    9: 'pt-9',
    10: 'pt-10',
    12: 'pt-12',
    16: 'pt-16',
    18: 'pt-18',
    20: 'pt-20',
    24: 'pt-24',
    32: 'pt-32',
    40: 'pt-40',
    48: 'pt-48',
    56: 'pt-56',
    64: 'pt-64',
  },
  'padding-top-sm': {
    0: 'sm:pt-0',
    1: 'sm:pt-1',
    2: 'sm:pt-2',
    3: 'sm:pt-3',
    4: 'sm:pt-4',
    5: 'sm:pt-5',
    6: 'sm:pt-6',
    8: 'sm:pt-8',
    9: 'sm:pt-9',
    10: 'sm:pt-10',
    12: 'sm:pt-12',
    16: 'sm:pt-16',
    18: 'sm:pt-18',
    20: 'sm:pt-20',
    24: 'sm:pt-24',
    32: 'sm:pt-32',
    40: 'sm:pt-40',
    48: 'sm:pt-48',
    56: 'sm:pt-56',
    64: 'sm:pt-64',
  },
  'padding-top-md': {
    0: 'md:pt-0',
    1: 'md:pt-1',
    2: 'md:pt-2',
    3: 'md:pt-3',
    4: 'md:pt-4',
    5: 'md:pt-5',
    6: 'md:pt-6',
    8: 'md:pt-8',
    9: 'md:pt-9',
    10: 'md:pt-10',
    12: 'md:pt-12',
    16: 'md:pt-16',
    18: 'md:pt-18',
    20: 'md:pt-20',
    24: 'md:pt-24',
    32: 'md:pt-32',
    40: 'md:pt-40',
    48: 'md:pt-48',
    56: 'md:pt-56',
    64: 'md:pt-64',
  },
  'padding-top-lg': {
    0: 'lg:pt-0',
    1: 'lg:pt-1',
    2: 'lg:pt-2',
    3: 'lg:pt-3',
    4: 'lg:pt-4',
    5: 'lg:pt-5',
    6: 'lg:pt-6',
    8: 'lg:pt-8',
    9: 'lg:pt-9',
    10: 'lg:pt-10',
    12: 'lg:pt-12',
    16: 'lg:pt-16',
    18: 'lg:pt-18',
    20: 'lg:pt-20',
    24: 'lg:pt-24',
    32: 'lg:pt-32',
    40: 'lg:pt-40',
    48: 'lg:pt-48',
    56: 'lg:pt-56',
    64: 'lg:pt-64',
  },
  'padding-top-xl': {
    0: 'xl:pt-0',
    1: 'xl:pt-1',
    2: 'xl:pt-2',
    3: 'xl:pt-3',
    4: 'xl:pt-4',
    5: 'xl:pt-5',
    6: 'xl:pt-6',
    8: 'xl:pt-8',
    9: 'xl:pt-9',
    10: 'xl:pt-10',
    12: 'xl:pt-12',
    16: 'xl:pt-16',
    18: 'xl:pt-18',
    20: 'xl:pt-20',
    24: 'xl:pt-24',
    32: 'xl:pt-32',
    40: 'xl:pt-40',
    48: 'xl:pt-48',
    56: 'xl:pt-56',
    64: 'xl:pt-64',
  },
  'padding-right': {
    0: 'pr-0',
    1: 'pr-1',
    2: 'pr-2',
    3: 'pr-3',
    4: 'pr-4',
    5: 'pr-5',
    6: 'pr-6',
    8: 'pr-8',
    9: 'pr-9',
    10: 'pr-10',
    12: 'pr-12',
    16: 'pr-16',
    18: 'pr-18',
    20: 'pr-20',
    24: 'pr-24',
    32: 'pr-32',
    40: 'pr-40',
    48: 'pr-48',
    56: 'pr-56',
    64: 'pr-64',
  },
  'padding-right-sm': {
    0: 'sm:pr-0',
    1: 'sm:pr-1',
    2: 'sm:pr-2',
    3: 'sm:pr-3',
    4: 'sm:pr-4',
    5: 'sm:pr-5',
    6: 'sm:pr-6',
    8: 'sm:pr-8',
    9: 'sm:pr-9',
    10: 'sm:pr-10',
    12: 'sm:pr-12',
    16: 'sm:pr-16',
    18: 'sm:pr-18',
    20: 'sm:pr-20',
    24: 'sm:pr-24',
    32: 'sm:pr-32',
    40: 'sm:pr-40',
    48: 'sm:pr-48',
    56: 'sm:pr-56',
    64: 'sm:pr-64',
  },
  'padding-right-md': {
    0: 'md:pr-0',
    1: 'md:pr-1',
    2: 'md:pr-2',
    3: 'md:pr-3',
    4: 'md:pr-4',
    5: 'md:pr-5',
    6: 'md:pr-6',
    8: 'md:pr-8',
    9: 'md:pr-9',
    10: 'md:pr-10',
    12: 'md:pr-12',
    16: 'md:pr-16',
    18: 'md:pr-18',
    20: 'md:pr-20',
    24: 'md:pr-24',
    32: 'md:pr-32',
    40: 'md:pr-40',
    48: 'md:pr-48',
    56: 'md:pr-56',
    64: 'md:pr-64',
  },
  'padding-right-lg': {
    0: 'lg:pr-0',
    1: 'lg:pr-1',
    2: 'lg:pr-2',
    3: 'lg:pr-3',
    4: 'lg:pr-4',
    5: 'lg:pr-5',
    6: 'lg:pr-6',
    8: 'lg:pr-8',
    9: 'lg:pr-9',
    10: 'lg:pr-10',
    12: 'lg:pr-12',
    16: 'lg:pr-16',
    18: 'lg:pr-18',
    20: 'lg:pr-20',
    24: 'lg:pr-24',
    32: 'lg:pr-32',
    40: 'lg:pr-40',
    48: 'lg:pr-48',
    56: 'lg:pr-56',
    64: 'lg:pr-64',
  },
  'padding-right-xl': {
    0: 'xl:pr-0',
    1: 'xl:pr-1',
    2: 'xl:pr-2',
    3: 'xl:pr-3',
    4: 'xl:pr-4',
    5: 'xl:pr-5',
    6: 'xl:pr-6',
    8: 'xl:pr-8',
    9: 'xl:pr-9',
    10: 'xl:pr-10',
    12: 'xl:pr-12',
    16: 'xl:pr-16',
    18: 'xl:pr-18',
    20: 'xl:pr-20',
    24: 'xl:pr-24',
    32: 'xl:pr-32',
    40: 'xl:pr-40',
    48: 'xl:pr-48',
    56: 'xl:pr-56',
    64: 'xl:pr-64',
  },
  'padding-bottom': {
    0: 'pb-0',
    1: 'pb-1',
    2: 'pb-2',
    3: 'pb-3',
    4: 'pb-4',
    5: 'pb-5',
    6: 'pb-6',
    8: 'pb-8',
    9: 'pb-9',
    10: 'pb-10',
    12: 'pb-12',
    16: 'pb-16',
    18: 'pb-18',
    20: 'pb-20',
    24: 'pb-24',
    32: 'pb-32',
    40: 'pb-40',
    48: 'pb-48',
    56: 'pb-56',
    64: 'pb-64',
  },
  'padding-bottom-sm': {
    0: 'sm:pb-0',
    1: 'sm:pb-1',
    2: 'sm:pb-2',
    3: 'sm:pb-3',
    4: 'sm:pb-4',
    5: 'sm:pb-5',
    6: 'sm:pb-6',
    8: 'sm:pb-8',
    9: 'sm:pb-9',
    10: 'sm:pb-10',
    12: 'sm:pb-12',
    16: 'sm:pb-16',
    18: 'sm:pb-18',
    20: 'sm:pb-20',
    24: 'sm:pb-24',
    32: 'sm:pb-32',
    40: 'sm:pb-40',
    48: 'sm:pb-48',
    56: 'sm:pb-56',
    64: 'sm:pb-64',
  },
  'padding-bottom-md': {
    0: 'md:pb-0',
    1: 'md:pb-1',
    2: 'md:pb-2',
    3: 'md:pb-3',
    4: 'md:pb-4',
    5: 'md:pb-5',
    6: 'md:pb-6',
    8: 'md:pb-8',
    9: 'md:pb-9',
    10: 'md:pb-10',
    12: 'md:pb-12',
    16: 'md:pb-16',
    18: 'md:pb-18',
    20: 'md:pb-20',
    24: 'md:pb-24',
    32: 'md:pb-32',
    40: 'md:pb-40',
    48: 'md:pb-48',
    56: 'md:pb-56',
    64: 'md:pb-64',
  },
  'padding-bottom-lg': {
    0: 'lg:pb-0',
    1: 'lg:pb-1',
    2: 'lg:pb-2',
    3: 'lg:pb-3',
    4: 'lg:pb-4',
    5: 'lg:pb-5',
    6: 'lg:pb-6',
    8: 'lg:pb-8',
    9: 'lg:pb-9',
    10: 'lg:pb-10',
    12: 'lg:pb-12',
    16: 'lg:pb-16',
    18: 'lg:pb-18',
    20: 'lg:pb-20',
    24: 'lg:pb-24',
    32: 'lg:pb-32',
    40: 'lg:pb-40',
    48: 'lg:pb-48',
    56: 'lg:pb-56',
    64: 'lg:pb-64',
  },
  'padding-bottom-xl': {
    0: 'xl:pb-0',
    1: 'xl:pb-1',
    2: 'xl:pb-2',
    3: 'xl:pb-3',
    4: 'xl:pb-4',
    5: 'xl:pb-5',
    6: 'xl:pb-6',
    8: 'xl:pb-8',
    9: 'xl:pb-9',
    10: 'xl:pb-10',
    12: 'xl:pb-12',
    16: 'xl:pb-16',
    20: 'xl:pb-20',
    24: 'xl:pb-24',
    32: 'xl:pb-32',
    40: 'xl:pb-40',
    48: 'xl:pb-48',
    56: 'xl:pb-56',
    64: 'xl:pb-64',
  },
  'padding-left': {
    0: 'pl-0',
    1: 'pl-1',
    2: 'pl-2',
    3: 'pl-3',
    4: 'pl-4',
    5: 'pl-5',
    6: 'pl-6',
    8: 'pl-8',
    9: 'pl-9',
    10: 'pl-10',
    12: 'pl-12',
    16: 'pl-16',
    18: 'pl-18',
    20: 'pl-20',
    24: 'pl-24',
    32: 'pl-32',
    40: 'pl-40',
    48: 'pl-48',
    56: 'pl-56',
    64: 'pl-64',
  },
  'padding-left-sm': {
    0: 'sm:pl-0',
    1: 'sm:pl-1',
    2: 'sm:pl-2',
    3: 'sm:pl-3',
    4: 'sm:pl-4',
    5: 'sm:pl-5',
    6: 'sm:pl-6',
    8: 'sm:pl-8',
    9: 'sm:pl-9',
    10: 'sm:pl-10',
    12: 'sm:pl-12',
    16: 'sm:pl-16',
    18: 'sm:pl-18',
    20: 'sm:pl-20',
    24: 'sm:pl-24',
    32: 'sm:pl-32',
    40: 'sm:pl-40',
    48: 'sm:pl-48',
    56: 'sm:pl-56',
    64: 'sm:pl-64',
  },
  'padding-left-md': {
    0: 'md:pl-0',
    1: 'md:pl-1',
    2: 'md:pl-2',
    3: 'md:pl-3',
    4: 'md:pl-4',
    5: 'md:pl-5',
    6: 'md:pl-6',
    8: 'md:pl-8',
    9: 'md:pl-9',
    10: 'md:pl-10',
    12: 'md:pl-12',
    16: 'md:pl-16',
    18: 'md:pl-18',
    20: 'md:pl-20',
    24: 'md:pl-24',
    32: 'md:pl-32',
    40: 'md:pl-40',
    48: 'md:pl-48',
    56: 'md:pl-56',
    64: 'md:pl-64',
  },
  'padding-left-lg': {
    0: 'lg:pl-0',
    1: 'lg:pl-1',
    2: 'lg:pl-2',
    3: 'lg:pl-3',
    4: 'lg:pl-4',
    5: 'lg:pl-5',
    6: 'lg:pl-6',
    8: 'lg:pl-8',
    9: 'lg:pl-9',
    10: 'lg:pl-10',
    12: 'lg:pl-12',
    16: 'lg:pl-16',
    18: 'lg:pl-18',
    20: 'lg:pl-20',
    24: 'lg:pl-24',
    32: 'lg:pl-32',
    40: 'lg:pl-40',
    48: 'lg:pl-48',
    56: 'lg:pl-56',
    64: 'lg:pl-64',
  },
  'padding-left-xl': {
    0: 'xl:pl-0',
    1: 'xl:pl-1',
    2: 'xl:pl-2',
    3: 'xl:pl-3',
    4: 'xl:pl-4',
    5: 'xl:pl-5',
    6: 'xl:pl-6',
    8: 'xl:pl-8',
    9: 'xl:pl-9',
    10: 'xl:pl-10',
    12: 'xl:pl-12',
    16: 'xl:pl-16',
    18: 'xl:pl-18',
    20: 'xl:pl-20',
    24: 'xl:pl-24',
    32: 'xl:pl-32',
    40: 'xl:pl-40',
    48: 'xl:pl-48',
    56: 'xl:pl-56',
    64: 'xl:pl-64',
  },
}
